import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';

import { Controllers } from '@shared/core/controllers';

import { Observable } from 'rxjs';
import * as Tokens from '@shared/core/tokens';

@Component({
    selector: 'shared-hero-background',
    templateUrl: './hero-background.shared.component.html',
    styleUrls: ['./hero-background.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeroBackgroundComponent {
    public backgroundImage$: Observable<string>;
    public isHomePage$: Observable<boolean>;
    public isLoyaltyPage$: Observable<boolean>;
    public isError404Page$: Observable<boolean>;
    public isLocationDetailsPage$: Observable<boolean>;
    public isCurrentLocationValid$: Observable<boolean>;
    public isAccountPage$: Observable<boolean>;
    public isOrderConfirmationPage$: Observable<boolean>;
    public currentLocationNo$: Observable<number>;
    public showOrderConfirmationHeroHeader: boolean;

    constructor(
        public controllers: Controllers,
        @Inject(Tokens.CONFIG_TOKEN) private _config: IConfig,
    ) {
        this.isHomePage$ = this.controllers.routes.isHomePage$();
        this.isLoyaltyPage$ = this.controllers.routes.isLoyaltyHomePage$();
        this.isLocationDetailsPage$ = this.controllers.routes.isLocationDetailsPage$();
        this.isAccountPage$ = this.controllers.routes.isAccountPage$();
        this.isError404Page$ = this.controllers.routes.isError404Page$();
        this.isOrderConfirmationPage$ = this.controllers.routes.isOrderConfirmationPage$();
        this.currentLocationNo$ = this.controllers.locations.currentLocationNoByRoute$();
        this.isCurrentLocationValid$ = this.controllers.locations.isLocationValid$();
        this.backgroundImage$ = this.controllers.images.heroHeaderImage$();
        this.showOrderConfirmationHeroHeader = this._config.isLiveViewEnabled;
    }
}
